<div class="assignment-tile-info-dialog-container">
  <section
    class="dialog-header"
        [ngStyle]="{
            background: 'var(--' + data?.assignment?.assignableType + ')'
        }"
    >
    <!-- Activity Asset Type -->
    <div class="activity-asset-type-container">
      <img
        class="activity-asset-type-icon"
        [src]="getAssignableTypeForIcon(data?.assignment)"
        />
      <span class="font-size-16x asset-type">
        {{ getCapAssignableTypeName(data?.assignment) }}
      </span>
    </div>

    <button (click)="close()" cdkFocusInitial class="top-right-closer">
      <mat-icon>close</mat-icon>
    </button>
  </section>

  <div mat-dialog-content class="assignment-tile-info-dialog-content">
    <!-- Upcoming / In Progress / Overdue / Submitted / Evaluated -->
    <status-tabs
      class="status-tabs-component"
      [assignment]="data?.assignment"
      [topTab]="true"
    ></status-tabs>

    <!-- Assignment Name -->
    <h2 class="h2-value assignment-name">{{ data.assignmentName }}</h2>

    <!-- Directions -->
    <section class="directions-container">
      <!-- Performance Directions -->
      @if (data.assetTypeId === assetTypeIds.PERFORM) {
        <p
          class="dialog-item"
          >
          <performance-directions
            [fontSize]="'font-size-large'"
            [assignment]="data?.assignment"
            [asset]="data?.assignment.asset"
            [maxAttempts]="formatMaxAttempts(data?.maxAttempts)"
          ></performance-directions>
        </p>
      }

      <!-- Mastery Workspace Directions -->
      @if (data.assetTypeId === assetTypeIds.COG_TUTOR) {
        <p
          class="dialog-item"
          >
          <cog-tutor-directions
            [fontSize]="'font-size-large'"
            [directions]="data?.assignment.asset.description"
          ></cog-tutor-directions>
        </p>
      }

      <!-- Concept Builder Directions -->
      @if (data.assetTypeId === assetActivityTypeIds.NON_MASTERY) {
        <p
          class="dialog-item"
          >
          <cog-tutor-directions
            [fontSize]="'font-size-large'"
            [directions]="data?.assignment.asset.description"
          ></cog-tutor-directions>
        </p>
      }

      <!-- Custom Activity Directions -->
      @if (data.assetTypeId === assetTypeIds.CUSTOM_ACT) {
        <p
          class="dialog-item"
          >
          <custom-activity-directions
            [fontSize]="'font-size-large'"
            [directions]="data?.assignment.asset.description"
          ></custom-activity-directions>
        </p>
      }

      <!-- Ready Check Assessment Directions -->
      @if (data.assetTypeId === assetTypeIds.READYCHECK) {
        <p
          class="dialog-item"
          >
          <ready-check-directions
            [fontSize]="'font-size-large'"
            [directions]="data?.assignment.asset.description"
          ></ready-check-directions>
        </p>
      }

      <!-- Module Directions -->
      @if (
        data.assignment.asset?.assetActivityTypeId &&
        data.assignment.asset?.assetActivityTypeId ===
        assetActivityTypeIds.IPA
        ) {
        <p
          class="dialog-item"
          >
          <assessment-directions
            [fontSize]="'font-size-large'"
            [assessmentDirection]="data?.assignment.asset.description"
          ></assessment-directions>
        </p>
      }

      <!-- Lesson Directions -->
      @if (
        data.assetTypeId === assetTypeIds.BUNDLE &&
        data.assignment.asset?.assetActivityTypeId !==
        assetActivityTypeIds.IPA
        ) {
        <p
          class="dialog-item"
          >
          <bundle-directions
            [fontSize]="'font-size-large'"
            [subjectId]="data.assignment.asset.subjectId"
            [directions]="data.assignment.asset.description"
            [objectives]="data.assignment.asset.objectives"
          ></bundle-directions>
        </p>
      }
    </section>

    <!-- Module Category -->
    @if (
      data.assignment.asset?.assetActivityTypeId &&
      data.assignment.asset?.assetActivityTypeId ===
      assetActivityTypeIds.IPA
      ) {
      <p
        class="dialog-item"
        >
        <span class="data-label-inline font-size-14px"
          >Part {{ data.assignment.asset?.categoryOrder }}:
        </span>
        <span class="data-value font-size-14px">{{
          data.assignment.asset?.displayName
        }}</span>
      </p>
    }

    <!-- Discover eBook Spine Title -->
    @if (
      data.assignment.asset &&
      (data.assetTypeId === assetTypeIds.EBOOK_ACT ||
      data.assignment.asset?.assetTypeId ===
      assetTypeIds.EBOOK_ACT)
      ) {
      <p
        class="dialog-item"
        >
        <span class="data-label-inline font-size-14px">Book Title: </span>
        <span class="data-value font-size-14px">{{
          data.assignment.asset?.bookName
        }}</span>
      </p>
    }

    <!-- Discover eBook Activity Type -->
    @if (
      data.assetTypeId === assetTypeIds.EBOOK_ACT ||
      data.assignment.asset?.assetTypeId === assetTypeIds.EBOOK_ACT
      ) {
      <p
        class="dialog-item"
        >
        <span class="data-label-inline font-size-14px"
          >Activity Type:
        </span>
        <span class="data-value font-size-14px">{{
          data.activityType
        }}</span>
      </p>
    }

    <!-- Start Date -->
    @if (data.startDate) {
      <p class="dialog-item">
        <span class="data-label-inline font-size-14px">Start Date: </span>
        <span class="data-value font-size-14px">{{ data.startDate }}</span>
      </p>
    }

    <!-- Due Date -->
    @if (data.dueDate) {
      <p
        class="dialog-item due-date-p"
        [ngClass]="getDueDateStatus(data.assignment)"
        >
        <span class="due-date-label data-label-inline font-size-14px"
          >Due Date:
        </span>
        <span class="due-date-value data-value font-size-14px">{{
          data.dueDate
        }}</span>
      </p>
    }

    <!-- Submitted Date -->
    @if (data.submittedDate) {
      <p class="dialog-item">
        <span class="data-label-inline font-size-14px">Submitted: </span>
        <span class="data-value font-size-14px">{{
          data.submittedDate
        }}</span>
      </p>
    }

    <!-- Evaluated Date -->
    @if (data.evaluatedDate) {
      <p class="dialog-item">
        <span class="data-label-inline font-size-14px">Evaluated: </span>
        <span class="data-value font-size-14px">{{
          data.evaluatedDate
        }}</span>
      </p>
    }

    <!-- Score Possible -->
    @if (getScorePossible(data.assignment)) {
      <p class="dialog-item">
        <span class="data-label-inline font-size-14px"
          >Score Possible:
        </span>
        <span class="data-value font-size-14px">{{
          getScorePossible(data.assignment)
        }}</span>
      </p>
    }

    <!-- Max Attempts -->
    @if (showMaxAttempts(data.assignment)) {
      <p class="dialog-item">
        <span class="data-label-inline font-size-14px"
          >Attempts Allowed:
        </span>
        @if (data.maxAttempts === -1) {
          <span
            class="data-value font-size-14px"
            >unlimited</span
            >
          }
          @if (data.maxAttempts != -1) {
            <span
              class="data-value font-size-14px"
              >{{ data.maxAttempts }}</span
              >
            }
          </p>
        }

        <!-- Custom Response Type -->
        @if (data.assetTypeId === assetTypeIds.CUSTOM_ACT) {
          <p
            class="dialog-item"
            >
            <span class="data-label-inline font-size-14px"
              >Response Type:
            </span>
            <span class="data-value font-size-14px">{{
              getCustomActivityResponseType(
              data.assignment.asset.responseType
              )
            }}</span>
          </p>
        }

        <!-- Level -->
        @if (
          data.assignment.asset?.levelIds &&
          data.assignment.asset?.levelIds.length > 0 &&
          !isMathCourse()
          ) {
          <p
            class="dialog-item"
            >
            <span class="data-label-inline font-size-14px"
              >{{
              data?.assignment?.asset?.subjectId === "COMP-SCI"
              ? "Course"
              : "Level"
              }}@if (multilevel(data.assignment.asset)) {
              <span>s</span>
              }:
            </span>
            <span class="data-value font-size-14px">
              {{ getLevelName(data.assignment.asset) }}</span
              >
            </p>
          }

          <!-- Unit -->
          @if (data.assignment.asset?.unit) {
            <p class="dialog-item">
              <span class="data-label-inline font-size-14px">Unit: </span>
              <span class="data-value font-size-14px">{{
                data.assignment.asset.unit
              }}</span>
            </p>
          }

          <!-- Lesson -->
          @if (
            data.assignment.asset?.lesson) {
            <p
              class="dialog-item"
              >
              <span class="data-label-inline font-size-14px">Lesson: </span>
              <span class="data-value font-size-14px">{{
                data.assignment.asset.lesson
              }}</span>
            </p>
          }

          <!-- Page -->
          @if (
            data.assignment.asset?.page
            ) {
            <p
              class="dialog-item"
              >
              <span class="data-label-inline font-size-14px">Page: </span>
              <span class="data-value font-size-14px">{{
                data.assignment.asset?.page
              }}</span>
            </p>
          }

          <!-- Activity Number -->
          @if (
            data.assignment.asset?.bookActivityNumber &&
            (data.assetTypeId === assetTypeIds.EBOOK_ACT ||
            data.assignment.asset?.assetTypeId ===
            assetTypeIds.EBOOK_ACT)
            ) {
            <p
              class="dialog-item"
              >
              <span class="data-label-inline font-size-14px"
                >Activity Number:
              </span>
              <span class="data-value font-size-14px">{{
                data.assignment.asset.bookActivityNumber
              }}</span>
            </p>
          }

          <!-- Lesson Skills (for Math) -->
          @if (
            data.assetTypeId === assetTypeIds.BUNDLE &&
            data.assignment.asset?.skills &&
            data.assignment.asset?.skills.length > 0
            ) {
            <div
              class="dialog-item"
              >
              <bundle-skills
                [fontSize]="'font-size-large'"
                [skills]="data.assignment.asset.skills"
              ></bundle-skills>
            </div>
          }

          <!-- Module activities -->
          @if (
            data.assignment.asset?.assetActivityTypeId &&
            data.assignment.asset?.assetActivityTypeId ===
            assetActivityTypeIds.IPA
            ) {
            <div
              class="activities-content"
              >
              <p class="activities-label">
                {{ data.assignment.compositeTaskAssignments.length }}
                {{
                getProperActivityWord(
                data.assignment.compositeTaskAssignments.length
                )
                }}
                - {{ getCompletionCount(data.assignment) }} submitted
              </p>
              <div class="activities-list">
                @for (
                  createActivity of data.assignment.asset.tasks; track trackByFn($index,
                  createActivity)) {
                  <div
                    class="activity"
                    >
                    <img
                      class="icon-23-x-23 activity-icon"
                        [ngClass]="{
                            'activity-icon-completed': getCompletedAt(
                                createActivity,
                                data.assignment
                            )
                        }"
                      alt="Activity Icon"
                      [src]="getIconPath(createActivity)"
                      [matTooltip]="createActivity?.displayName"
                      />
                    @if (getCompletedAt(createActivity, data.assignment)) {
                      <mat-icon
                        class="icon-23-x-23 activity-check"
                        >done</mat-icon
                        >
                      }
                    </div>
                  }
                </div>
              </div>
            }

            <!-- Lesson activities -->
            @if (
              data.assetTypeId === assetTypeIds.BUNDLE &&
              (!data.assignment.asset?.assetActivityTypeId ||
              (data.assignment.asset?.assetActivityTypeId &&
              data.assignment.asset?.assetActivityTypeId !==
              assetActivityTypeIds.IPA))
              ) {
              <div
                class="activities-content"
                >
                <p class="activities-label">
                  {{ data.assignment.compositeTaskAssignments.length }}
                  {{ getProperActivityWord(data.assignment.asset.tasks.length) }}
                  - {{ getCompletionCount(data.assignment) }} submitted
                </p>
                <div class="activities-list">
                  @for (
                    lessonActivity of data.assignment.asset.tasks; track trackByFn(i,
                    lessonActivity); let i = $index) {
                    <div
                      class="activity"
                      >
                      <img
                        class="icon-23-x-23 activity-icon"
                        [ngClass]="{
                            'activity-icon-completed': getCompletedAt(
                                lessonActivity,
                                data.assignment
                            )
                        }"
                        [src]="getIconPath(lessonActivity)"
                        [matTooltip]="lessonActivity?.displayName"
                        />
                      @if (getCompletedAt(lessonActivity, data.assignment)) {
                        <mat-icon
                          class="icon-23-x-23 activity-check"
                          [matTooltip]="lessonActivity?.displayName"
                          >done</mat-icon
                          >
                        }
                      </div>
                    }
                  </div>
                </div>
              }

              <!-- Score -->
              @if (data?.assetTypeId !== assetTypeIds.EREADER) {
                <div
                  class="activity-score-container"
                  >
                  <h3 class="h2-value score-title">Score</h3>
                  <div class="score-value-container">
                    <mat-icon
                      class="tile-icon check-circle"
                      [ngClass]="getCheckCircleColor(data.assignment)"
                      >check_circle_outline</mat-icon
                      >
                      @if (data?.assetTypeId !== assetTypeIds.EREADER) {
                        <span
                          class="data-value font-size-12px activity-score"
                          >
                          {{ getGrades(data.assignment) }}
                          <!-- submitted late -->
                          @if (data.assignment?.dueStatus === 'submittedLate') {
                            <span
                              class="submittedLate"
                              >
                              (Submitted Late)
                            </span>
                          }
                          <!-- Overdue but Evaluated -->
                          @if (
                            getDueDateStatus(data.assignment) ===
                            'overdueButEvaluated'
                            ) {
                            <span
                              class="overdueButEvaluated"
                              >
                              (Overdue but Evaluated)
                            </span>
                          }
                          <!-- Due Today but Evaluated -->
                          @if (
                            getDueDateStatus(data.assignment) ===
                            'dueTodayEvaluated'
                            ) {
                            <span
                              class="dueTodayButEvaluated"
                              >
                              (Due Today but Evaluated)
                            </span>
                          }
                          <!-- Due This Week but Evaluated -->
                          @if (
                            getDueDateStatus(data.assignment) ===
                            'dueThisWeekEvaluated'
                            ) {
                            <span
                              class="dueTodayButEvaluated"
                              >
                              (Due This Week but Evaluated)
                            </span>
                          }
                        </span>
                      }
                    </div>
                  </div>
                }

                <!-- Written Feedback -->
                @if (data.assignment.feedback) {
                  <section
                    class="written-feedback-container"
                    >
                    <h3 class="h2-value feedback-title">Feedback</h3>
                    <p
                      class="normal-paragraph font-size-12px feedback-text"
                      [innerHTML]="data.assignment.feedback"
                    ></p>
                    <span class="sub-title font-size-10px feedback-sent">
                      <span class="sub-title-label">Sent: </span
                        >{{ data.assignment.feedbackUpdatedAt }}
                      </span>
                    </section>
                  }
                </div>

                <div mat-dialog-actions class="assignment-tile-info-dialog-actions">
                  <button
                    class="standard-outline-button button-small"
                    color="primary"
                    (click)="close()"
                    cdkFocusInitial
                    >
                    Close
                  </button>

                  <!-- Launch Button -->
                  @if (data?.showLaunchButton) {
                    <status-launch-buttons
                      class="launch-button-component"
                      [assignment]="data?.assignment"
                      (click)="launchButton()"
                    ></status-launch-buttons>
                  }
                </div>
              </div>
